import { useEffect, useState } from 'react';
import '../../styles/EduComponents/Passion.css';
import calander from '../../assets/Images/calander.webp';
import notification from '../../assets/Images/notification - Copy.webp';
import search from '../../assets/Images/search - Copy.webp';
import info from '../../assets/Images/info.webp';
import work from '../../assets/Images/work - Copy.webp';
import money from '../../assets/Images/money - Copy.webp';
const Passion = () => {


  const handleClick = () => {
    const tidycalUrl = process.env.REACT_APP_TIDYCAL_URL;
; // replace with your actual TidyCal link
    try {
      window.open(tidycalUrl, '_blank', 'width=600,height=700');
    } catch (error) {
      console.error('Error opening TidyCal booking page:', error);
      alert('An error occurred while trying to open the booking page. Please try again later.');
    }
  };

  
    return (
      

      <section className="passion-container">
        <section className='passion-container1'>

      <div className="left-text">
        <h1 className='lt1'>
          Are you a passionate<span className="highlight"><br />instructor</span> ?
        </h1>
            </div>

            <div className= "right-text">
                <p className='rtp'>
                  The daunting reality of administrative tasks can quickly overshadow the thrill of starting your academy. Imagine spending more time on:
                </p>
            </div>
        </section>
  
  
        <div className="passion-feature">
          <div className="passion-text left">
            <h3 className='pt3'>Tedious Attendance Tracking</h3>
            <p className='ptp'>
              Manually recording who's present, leading to errors and wasted time.
            </p>
            <a href="#" onClick={handleClick} className='pta'>Book A Demo</a>
          </div>
          <div className="passion-image">
            <img src={calander} alt="Progress Graph" />
          </div>
        </div>
  
        <div className="passion-feature reverse">
          <div className="passion-image">
            <img src={notification} alt="Dashboard UI" />
          </div>
          <div className="passion-text right">
            <h3 className='pt3'>Constant Communication Overload</h3>
            <p className='ptp'>
              Sending individual reminders and updates, draining your focus.
            </p>
            <a href="#" onClick={handleClick} className='pta'>Book A Demo</a>
          </div>
        </div>
        <div className="passion-feature">
          <div className="passion-text left">
            <h3 className='pt3'>Lack of Curriculum Oversight</h3>
            <p className='ptp'>
              Wondering if all instructors are consistently delivering your academy's quality.
            </p>
            <a href="#" onClick={handleClick} className='pta'>Book A Demo</a>
          </div>
          <div className="passion-image">
            <img src={search} alt="Progress Graph" />
          </div>
        </div>
  
        <div className="passion-feature reverse">
          <div className="passion-image">
            <img src={info} alt="Dashboard UI" />
          </div>
          <div className="passion-text right">
            <h3 className='pt3'>Time-Consuming Lesson Planning</h3>
            <p className='ptp'>
              Struggling to recall past lessons and plan effectively for the next class.
            </p>
            <a href="#" onClick={handleClick} className='pta'>Book A Demo</a>
          </div>
        </div>

        <div className="passion-feature">
          <div className="passion-text left">
            <h3 className='pt3'>Frustrating Progress Reporting</h3>
            <p className='ptp'>
             Spending hours creating reports that offer little real insight to parents.
            </p>
            <a href="#" onClick={handleClick} className='pta'>Book A Demo</a>
          </div>
          <div className="passion-image">
            <img src={work} alt="Progress Graph" />
          </div>
        </div>

        <div className="passion-feature reverse">
          <div className="passion-image">
            <img src={money} alt="Dashboard UI" />
          </div>
          <div className="passion-text right">
            <h3 className='pt3'>Awkward Payment Chasing</h3>
            <p className='ptp'>
              Feeling uncomfortable reminding parents about overdue fees.
            </p>
            <a href="#" onClick={handleClick} className='pta'>Book A Demo</a>
          </div>
        </div>
      </section>

      
      
    );
  };
  
  export default Passion;